import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ISelectMolecule } from '../../molecules/select/select.interface';
import { customSelectRequiredValidator } from '../../../shared/helpers/validators/select.required/validators.select.required';

@Component({
    selector: 'mlp-ng-location-select',
    templateUrl: './location-select.component.html',
    styleUrls: ['./location-select.component.scss'],
})

export class LocationSelectSharedComponent {
    @Input() backgroundImage = '/assets/img/background1.jpg';
    @Input() options: Array<ISelectMolecule> = [];
    @Input() logoSrc = '/assets/logo/pf_formerly_mlp.svg';
    @Input() logoAlt = 'logo';

    @Output() submitted: EventEmitter<FormGroup> = new EventEmitter();
    form: FormGroup;

    get sport(): AbstractControl { return this.form.get('sport'); }
    get location(): AbstractControl { return this.form.get('location'); }

    constructor(private formBuilder: FormBuilder) {
        this.form = this.formBuilder.group({
            sport: [{
                description: 'Select Sport',
                icon: 'custom-sports',
                data: null
            }, customSelectRequiredValidator()],
            location: ['', Validators.required]
        });
    }

    submit(): void {
        this.markFormControlsAsTouched(this.form);
        this.submitted.emit(this.form);
    }

    /**
     * In some cases form does not behave like it was submitted. We need to touch all form elements
     *
     * @param formGroup FormGroup
     */
    markFormControlsAsTouched(formGroup: FormGroup): void {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            control.markAsTouched({onlySelf: true});
        });
    }
}
